/* This is API version of store model */
export const state = () => ({

  host: process.env.apiUrl,
  entranceButton: false,
  mobileMenuOpen: false,
  menuItems: {
    top: {
      loaded: false,
      items: [],
    },
    btm: {
      loaded: false,
      items: [],
    },
    left: {
      loaded: false,
      items: [],
    },
    footer: {
      loaded: false,
      items: [
        {
          id: 1001,
          name:'О нас',
          link: '/company/',
          parent_id: null,
          menuItem: [
              {
                 id: 1001,
                 parent_id: 1001,
                 name: 'О компании',
                 link: '/company',
                 description: '',
              },
              {
                id: 1002,
                parent_id: 1001,
                name: 'История',
                link: '/company/history',
                description: '',
              },
              {
                id: 1003,
                parent_id: 1001,
                name: 'Команда',
                link: '/company/people',
                description: '',
              },
              {
                id: 1004,
                parent_id: 1001,
                name: 'Документы',
                link: '/company/docs',
                description: '',
              },
          ]
        },
        {
          name:'Клиентам',
          id: 1002,
          menuItem: [
            {
              parent_id: 1002,
              name: 'Брендам',
              link: '/brands/',
              description: ' Russ Outdoor работает над имиджем города,\n' +
                'развивая инфраструктуру и улучшая качество жизни людей.',
            },
            {
              parent_id: 1002,
              name: 'Поставщикам',
              link: '/suppliers/',
              description: ' Russ Outdoor работает над имиджем города,\n' +
                '             развивая инфраструктуру и улучшая качество жизни людей.',
            },
            {
              parent_id: 1002,
              name: 'Партнерам',
              link: '/partners/',
              description: ' Russ Outdoor работает над имиджем города,\n' +
                '             развивая инфраструктуру и улучшая качество жизни людей.',
            },
            {
              parent_id: 1002,
              name: 'Городу',
              link: '/cities/',
              description: ' Russ Outdoor работает над имиджем города,\n' +
                '             развивая инфраструктуру и улучшая качество жизни людей.',
            },
          ]
        },
        {
          name:'Продукты',
          id: 1003,
          menuItem: [
            {
              parent_id: 1003,
              name: 'Outdoor',
              link: '/products/outdoor/',
            },
            {
              parent_id: 1003,
              name: 'Indoor',
              link: '/products/indoor/',
            },
            {
              parent_id: 1003,
              name: 'Special',
              link: '/products/special/',
            },
            // {
            //   parent_id: 1003,
            //   name: 'City',
            //   link: '/products/city/',
            // },
          ]
        },
        {
          name:'Новости',
          id: 1004,
          menuItem: [
            {
              parent_id: 1004,
              name: 'Свежие новости',
              link: '/news/',
            },
            {
              parent_id: 1004,
              name: 'Мировой опыт',
              link: '/world/',
            },
            {
              parent_id: 1004,
              name: 'Лучшие кейсы',
              link: '/creative/',
            },
            {
              parent_id: 1004,
              name: 'Cоцпроекты',
              link: '/social-projects/',
            },
          ]
        },
      ],
    },
    social: {
      loaded: false,
      items: [],
    },
    toppromo: {
      loaded: false,
      items: [],
    }

  },
});




export const mutations = {
  setMenu: function (state, { type, items }) {
    const menuItemsFinal = [];
    // блокируем меню;
    const isMenuNone = {
      'top': [],
      'btm': [],
      'left': [],
      'footer': [],
      'social': [],
    }
    if(Array.isArray(items)) {
      items.forEach(menuItem => {
          const url = menuItem.url ? menuItem.url : (menuItem.id === 2000 ? 'https://www.russoutdoor.ru/sales/' : null);
          menuItemsFinal.push({
             id: menuItem.id,
             name: menuItem.name,
             link: menuItem.link,
             url: url,
             title: menuItem.title,
             description: menuItem.description,
             keywords: menuItem.keywords,
             items: menuItem.items,
          });
      });
      state.menuItems[type].items = menuItemsFinal;
    }
    state.menuItems[type].loaded = true;
  },
};

export const actions = {
  /* Load menu
  * @param mId = [top, btm, left, social]
  * */

  async loadMenu({ commit, dispatch, state }, mId) {

    return  await this.$axios.get(`${state.host}/methods/menu/get/?mid=${mId}`).then(
      (response) => {
        //console.log(response.data)
        commit('setMenu', { type: mId, items: response.data });
        return true;
      },
      (error) => {
        dispatch('showRequestError', error, { root: true });
        return false;
      }
    );
  },

  // async loadMenu({}) {
  //   return await new Promise(resolve => {
  //     setTimeout(()=>{
  //       resolve(state)
  //     },1000)
  //   })
  // },

  // async loadMenu({ commit, dispatch, state }, mId) {
  //   return await new Promise(resolve => {
  //     setTimeout(()=>{

  //       resolve(state)
  //       //commit('setMenu', { type: mId, items: response.data });
  //       return true;
  //     },1000)
  //   })
  // },

};


export const getters = {

  menuTop(state) {
    return Value => {
        return state.menuItems.top.loaded ? state.menuItems.top.items.find(items => items.link === Value).items: null;
    }
  },
   menuProducts(state) {
       return state.menuItems.footer.items.find(items => items.id === 1003);
   },
   menuNews(state) {
      return state.menuItems.footer.items.find(items => items.id === 1004);
   }
}



// WEBPACK FOOTER //
// ./store/menu.js